import {
  Input,
  Select,
  FormControlWrapper,
  Button,
  TextArea
} from '../uiLib'
import { defaultValidators } from '../../lib/validation'
import ContactFieldsOptions from './ContactFieldOptions'

export default ({ t, user, contactForm, supportCategories, _handleSubmit, handleSubmit, loading, initialize }) => (
  <div className="content">
    <h4 className="is-size-4 m-b-md">{t('common:contact-form_user-support')}</h4>
    <div className="m-b-md">
      {t('common:contact-form_locate-dealer')} <a href="https://www.mazdausa.com/" target="_blank">www.mazdausa.com</a>
    </div>
    <div className="m-b-md">{t('common:mazda-contact-support_line-2')}</div>
    <div className="m-b-md has-text-danger">{t('common:contact-form_note')}</div>    
    <form onSubmit={handleSubmit(_handleSubmit)} className="ma-contact-form columns">
      <div className="column is-8">
        <div className="m-b-lg">
          <Select
            id="contactCategory"
            name="contactCategory"
            label={t('common:contact-form_select-category')}
            size="normal"
            disabled={loading}
            required
            formComponent
            horizontal
            placeholder={t('common:contact-form_select-category')}
            validate={[
              defaultValidators.required
            ]}
            values={supportCategories.map(item => ({ value: item.id, label: t(item.label) }))}
            onChange={() => initialize({})} />
          <FormControlWrapper
            horizontal
            label={t('common:name')}
            size="normal">
            <label className="label is-normal has-text-white">
              {user.first_name} {user.last_name}
            </label>
          </FormControlWrapper>
          <FormControlWrapper
            horizontal
            label={t('common:contact-form_email-phone')}
            size="normal">
            <label className="label is-normal has-text-white">
              {user.username} / {user.phone}
            </label>
          </FormControlWrapper>
          <ContactFieldsOptions categoriesForField={[5, 6, 7]} contactForm={contactForm}>
            <Input
              id="model"
              name="model"
              label={t('common:contact-form_model')}
              size="normal"
              disabled={loading}
              horizontal
              formComponent
              validate={[
                defaultValidators.required
              ]} />
            <Input
              id="year"
              name="year"
              label={t('common:contact-form_year')}
              size="normal"
              disabled={loading}
              horizontal
              formComponent
              validate={[
                defaultValidators.required
              ]} />
            <Input
              id="vin"
              name="vin"
              label={t('common:vin')}
              size="normal"
              disabled={loading}
              horizontal
              formComponent
              validate={[
                defaultValidators.required,
                defaultValidators.length(17)
              ]} />
          </ContactFieldsOptions>
          <ContactFieldsOptions categoriesForField={[5]} contactForm={contactForm}>
            <Input
              id="device_used"
              name="device_used"
              label={t('common:contact-form_device_used')}
              size="normal"
              disabled={loading}
              required
              horizontal
              formComponent
              validate={[
                defaultValidators.required
              ]} />
          </ContactFieldsOptions>
        </div>
        <TextArea
          id="message"
          name="message"
          label={t('common:contact-form_descride_issue')}
          size="normal"
          disabled={loading}
          required
          horizontal
          formComponent
          validate={[
            defaultValidators.required
          ]} />
        <FormControlWrapper
          horizontal
          labelOffset>
          <Button
            disabled={loading}
            loading={loading}
            outlined
            btType="primary"
          >
            {t('common:submit')}
          </Button>
        </FormControlWrapper>
      </div>
    </form>
  </div>
)



// WEBPACK FOOTER //
// ./components/Contact/index.js